import { PlantStructure } from "@/property/shared/entities/PlantEntity";
import { Form } from "@/shared/form/Form";

export class UpdatePlantStructureForm extends Form<PlantStructure> {
  protected definition = {};
}
